import { Component, OnInit, ViewChild, ElementRef, Input, Renderer2, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-questionary-badge',
  templateUrl: './questionary-badge.component.html',
  styleUrls: ['./questionary-badge.component.css']
})
export class QuestionaryBadgeComponent implements OnInit {

    //input data
    @Input()
    questionaryquestionbadgecode: string;
    @Input()
    questionaryquestionbadgetitle: string;
    @Input()
    questionaryquestionbadgemessage: string;

    //elements
    @ViewChild('achievementwrapper') achievement: ElementRef; //achievement wrapper reference
    @ViewChild('achievementbodyclone') achievementbodyclone: ElementRef; //achievement wrapper reference
    @ViewChild('achievementbody') achievementbody: ElementRef; //achievement wrapper reference

    //output
    @Output() badgeanimationendevent = new EventEmitter<boolean>(); //event: animationendevent

    constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    }

    //on after view init
    ngAfterViewInit() {

        //set achivement body auto height
        this.achievementbody.nativeElement.style = "--auto-height: " + this.achievementbodyclone.nativeElement.offsetHeight + "px;";
        
        //event handler for achievement wrapper animation
        this.renderer.listen(this.achievement.nativeElement, 'animationend', (evt) => {
            if (evt.animationName == "slideDown") {
                this.badgeanimationendevent.emit(true); //emit event
            }
        });

        //start animation
        this.achievement.nativeElement.classList.remove("animation");
        setTimeout(() => this.achievement.nativeElement.classList.add("animation"), 200);
    }
}


